import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/useToast';
import Toast from '../components/Toast';
import './Auth.css';

function validate(form) {
  const e = {};
  if (!form.name.trim())  e.name = 'Full name is required.';
  if (!form.email.trim()) e.email = 'Email is required.';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Enter a valid email.';
  if (form.password.length < 6) e.password = 'Password must be at least 6 characters.';
  if (form.password !== form.confirm) e.confirm = 'Passwords do not match.';
  return e;
}

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const { toasts, toast } = useToast();
  const [form, setForm] = useState({ name: '', email: '', password: '', confirm: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

  const set = (k, v) => { setForm(f => ({ ...f, [k]: v })); setErrors(e => ({ ...e, [k]: '', general: '' })); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate(form);
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setLoading(true);
    await new Promise(r => setTimeout(r, 700));
    const result = register(form.name, form.email, form.password);
    setLoading(false);
    if (result.ok) {
      toast('Account created! Welcome to NextGenHub.', 'success');
      setTimeout(() => navigate('/dashboard'), 600);
    } else {
      setErrors({ general: result.error });
    }
  };

  return (
    <>
      <Toast toasts={toasts} />
      <div className="auth-page">
        <div className="auth-left">
          <div className="auth-brand">
            <Link to="/" className="auth-logo">
              <div className="auth-logo-mark">NG</div>
              NextGenHub
            </Link>
          </div>
          <div className="auth-hero-text">
            <h2>Join 200+ companies building with NextGenHub.</h2>
            <p>Create your account to get started with your free quote, track project progress, and stay in sync with our team.</p>
          </div>
          <div className="auth-perks">
            {['Free 30-min discovery call','Proposal within 48 hours','No lock-in contracts','30-day post-launch support'].map(p => (
              <div key={p} className="auth-perk"><span className="perk-check">✓</span>{p}</div>
            ))}
          </div>
        </div>

        <div className="auth-right">
          <div className="auth-card">
            <h1>Create account</h1>
            <p className="auth-sub">Get started with NextGenHub Life — it's free</p>

            <form onSubmit={handleSubmit} noValidate>
              {errors.general && <div className="auth-error">{errors.general}</div>}

              <div className="fg">
                <label>Full Name</label>
                <input value={form.name} onChange={e => set('name', e.target.value)} placeholder="Ravi Kumar" className={errors.name ? 'error' : ''} autoComplete="name" />
                {errors.name && <div className="field-error">{errors.name}</div>}
              </div>
              <div className="fg">
                <label>Work Email</label>
                <input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="you@company.com" className={errors.email ? 'error' : ''} autoComplete="email" />
                {errors.email && <div className="field-error">{errors.email}</div>}
              </div>
              <div className="fg pw-fg">
                <label>Password</label>
                <div className="pw-wrap">
                  <input type={showPw ? 'text' : 'password'} value={form.password} onChange={e => set('password', e.target.value)} placeholder="At least 6 characters" className={errors.password ? 'error' : ''} />
                  <button type="button" className="pw-toggle" onClick={() => setShowPw(s => !s)}>{showPw ? '🙈' : '👁'}</button>
                </div>
                {errors.password && <div className="field-error">{errors.password}</div>}
              </div>
              <div className="fg">
                <label>Confirm Password</label>
                <input type="password" value={form.confirm} onChange={e => set('confirm', e.target.value)} placeholder="Repeat password" className={errors.confirm ? 'error' : ''} />
                {errors.confirm && <div className="field-error">{errors.confirm}</div>}
              </div>

              <button type="submit" className="btn-grad auth-submit" disabled={loading}>
                {loading ? <><span className="spinner" /> Creating account…</> : 'Create account →'}
              </button>
            </form>
            <p className="auth-switch">Already have an account? <Link to="/login">Log in →</Link></p>
          </div>
        </div>
      </div>
    </>
  );
}
